// extracted by mini-css-extract-plugin
export default {"twoCols":"styles_twoCols__eYxJC","twoColsInner":"styles_twoColsInner__4wpQN","flip":"styles_flip__kjtuo"};